import { ReactNode, useEffect, useState } from "react";

const RELOAD_CHECK = `cache-busting-vvrrffppnnhh`;

export default function CacheBuster({ children }: { children: ReactNode }) {
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const isReloadDone = url.searchParams.has(RELOAD_CHECK);

    if (isReloadDone) {
      // 주소창에서 쿼리스트링 제거
      url.searchParams.delete(RELOAD_CHECK);
      window.history.replaceState(null, "", url.pathname + url.search + url.hash);
    } else {
      // 쿼리스트링 추가 후 강제 새로고침 (단, history에는 남기지 않음)
      url.searchParams.set(RELOAD_CHECK, Date.now().toString());
      setIsReloading(true); // 상태값은 잠깐만 true가 됨
      window.location.replace(url.toString()); // history에 남지 않도록
    }
  }, []);

  // 쿼리스트링 붙이는 순간 리로드 발생하므로, 이 시점엔 컴포넌트 안 보이게
  if (isReloading) return null;

  return <>{children}</>;
}
